$(function() {
    const $videoSec = document.querySelector('.js-video-sec');

    function lightboxVideoPlay(self, secMedia) {
        let type = self.getAttribute('data-lightbox-type'),
            src = self.getAttribute('data-lightbox-url'),
            yPlay = `https://www.youtube.com/embed/${src}?rel=0&autoplay=1&loop=1&mute=0&controls=0`,
            vPlay = `https://player.vimeo.com/video/${src}?autoplay=1&loop=1&muted=0&controls=0`;

        setTimeout(function() {
            if (self.classList.contains('open-lightbox')) {
                if (type === 'video' && src.length) {
                    self.parentNode.querySelector('.video-sec__inner').innerHTML = `
                <div class="videobg video-iframe">
                    <div class="videobg-width">
                        <div class="videobg-aspect">
                            <div class="videobg-make-height">
                                <div class="videobg-hide-controls">
                                    <video loop autoplay playsinline class="fullscreen-bg__video clip-svg">
                                        <source src="${src}" type="video/mp4">
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
                } else if (type === 'youtube' && src.length) {
                    self.parentNode.querySelector('.video-sec__inner').innerHTML = `
                <div class="videobg video-iframe">
                    <div class="videobg-width">
                        <div class="videobg-aspect">
                            <div class="videobg-make-height">
                                <div class="videobg-hide-controls">
                                    <iframe src="${yPlay}" frameborder="0" allow="autoplay; encrypted-media"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
                } else if (type === 'vimeo' && src.length) {
                    self.parentNode.querySelector('.video-sec__inner').innerHTML = `
                <div class="videobg video-iframe">
                    <div class="videobg-width">
                        <div class="videobg-aspect">
                            <div class="videobg-make-height">
                                <div class="videobg-hide-controls">
                                    <iframe src="${vPlay}" frameborder="0" allow="autoplay"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
                }
            } else {
                self.parentNode.querySelector('.video-sec__inner').innerHTML = `${secMedia}`;
            }
        }, 500);
    }

    function isMobile() {
        return /Mobi|Android/i.test(navigator.userAgent);
    }

    if ($videoSec) {
        const secMedia = $videoSec.querySelector('.video-sec__inner').innerHTML;

        let crossCursor = document.createElement('div');
        crossCursor.classList.add('custom-cross-cursor');

        $videoSec.addEventListener('click', function H(e) {
            e.preventDefault();
            let __this = this.querySelector('.js-custom-cursor');
            __this.classList.toggle('open-lightbox');
            this.querySelector('.video-sec__inner').classList.toggle('open-lightbox');

            if (isMobile()) {
                if (__this.classList.contains('open-lightbox')) {
                    __this.classList.add('fade-out');
                    setTimeout(() => {
                        __this.style.display = 'none';
                        $videoSec.append(crossCursor);
                        crossCursor.classList.add('show');
                    }, 500);
                } else {
                    crossCursor.classList.remove('show');
                    setTimeout(() => {
                        crossCursor.remove();
                        __this.classList.remove('fade-out');
                        __this.style.display = 'block';
                    }, 500);
                }
            }
            lightboxVideoPlay(__this, secMedia);
        });
    }

    //Video background
    let timeoutId,
        $videoBgAspect = $(".videobg-aspect"),
        $videoBgWidth = $(".videobg-width"),
        videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();

    function videobgEnlarge() {
        let windowAspect = $(window).height() / $(window).width();
        if(windowAspect > videoAspect) {
            $videoBgWidth.width(`${windowAspect / videoAspect * 100}%`);
        } else {
            $videoBgWidth.width(`${100}%`);
        }
    }

    $(window).resize(function() {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(videobgEnlarge, 100);
    });

    videobgEnlarge();
});